import { FormFieldTypes } from "../../../../../data/formFieldType";
import { GridColumnType } from "../../../../../data/gridColumnType";


export const viewManualAccountData = {
    name: "viewManualAccountData",
    initialState: {
        appeal: 0,
        transitioning: 0,
        distinguished: 0,
        gmaCourse: 0,
        internalNotes: ''
    },
    formFields: [
        {
            id: "internalNotes",
            lable: "Internal Notes",
            Field_Name: "Internal Notes",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "internalNotes",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-md-12 mb-2",
            },
        },
        {
            id: "appeal",
            lable: "Appeal",
            Field_Name: "Appeal",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "appeal",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-md-3 mb-2 mt-3",
            },
        },
        {
            id: "transitioning",
            lable: "Transitioning",
            Field_Name: "Transitioning",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "transitioning",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-md-3 mb-2 mt-3",
            },
        },
        {
            id: "distinguished",
            lable: "Distinguished",
            Field_Name: "Distinguished",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "distinguished",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-md-3 mb-2 mt-3",
            },
        },
        {
            id: "gmaCourse",
            lable: "GMA Course",
            Field_Name: "GMA Course",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "gmaCourse",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-md-3 mb-2 mt-3",
            },
        },
    ],
    formSetting: {
        isViewOnly: false
    }
}

export const ViewManualAccountconfig = {
    columns: [

        {
            name: "File Name",
            fieldName: "documentProofName",
            allowShort: false,
            colType: GridColumnType.Text,
        },
        {
            name: "File Link",
            fieldName: "documentProof",
            allowShort: false,
            colType: GridColumnType.LINK,
            colSettings: {
                isOpenNewTab: true,
                url: "$certificateLink", // need to add that property in our object  
            },
        },
    ],
};


export const dateviewManualAccountData = {
    name: "CreateAccountManagement",
    initialState: {
        entryCreatedDate: null,
        accountCreatedDate: null,
        gmpNumber: ''
    },
    formFields: [

        {
            id: "entryCreatedDate",
            lable: "Entry Created Date",
            Field_Name: "Entry Created Date",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "entryCreatedDate",
            fieldSetting: {
                placeholder: "Select",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-6 mb-2",
            },
        },

        {
            id: "accountCreatedDate",
            lable: "Account Created Date ",
            Field_Name: "Account Created Date ",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "accountCreatedDate",
            fieldSetting: {
                placeholder: "Select",
            },
            style: {
                containerCss: "col-lg-6 mb-2 ",
            }
        },
    ],
    formSetting: {
        isViewOnly: false
    }
}